import React, { useState } from "react";
import { Settings as SettingsIcon, Layers } from "lucide-react";
import { SalaryComponentsManager } from "./SalaryComponentsManager";
import { SalaryTemplatesManager } from "./SalaryTemplatesManager";

// Wrapper that gives Settings → Salary Structure two sub-tabs:
//   Components — the master library (Phase 1)
//   Templates  — reusable bundles of components (Phase 2)
// Per-employee assignment lands in Phase 3.

export const SalaryStructureManager = () => {
  const [tab, setTab] = useState('components');

  const tabCls = (k) =>
    'px-3 py-[6px] rounded-lg text-[14px] font-semibold cursor-pointer border ' +
    (tab === k
      ? 'bg-bg2 border-b1 text-t0'
      : 'bg-transparent border-transparent text-t2 hover:text-t0');

  return (
    <div>
      <div className="flex items-center gap-1 mb-4 border-b border-b0 pb-2">
        <button className={tabCls('components')} onClick={() => setTab('components')}>
          <SettingsIcon size={11} className="inline mr-1 -mt-[2px]" />
          Components
        </button>
        <button className={tabCls('templates')} onClick={() => setTab('templates')}>
          <Layers size={11} className="inline mr-1 -mt-[2px]" />
          Templates
        </button>
      </div>

      {tab === 'components' && <SalaryComponentsManager />}
      {tab === 'templates'  && <SalaryTemplatesManager />}
    </div>
  );
};
